import React from 'react';
import Layout from '../components/Layout';

function AffilateProgramVAP() {
    return (
        <Layout>
            <div className="container">
                <div className="row justify-content-center">
                    <div className="col">

                        {/* HEADER */}
                        <div
                            style={{
                                display: 'flex',
                                alignItems: 'center',
                                marginTop: '40px',
                                marginBottom: '30px',
                            }}
                            className="flex-column flex-md-row"
                        >
                            {/* LEFT: LOGO */}
                            <div
                                style={{ flex: '0 0 auto' }}
                                className="text-center text-md-start mb-3 mb-md-0"
                            >
                                <img
                                    src="https://viron.network/assets/img/viron-logo.svg"
                                    alt="VIRON Network Advisor"
                                    className="img-logo-center"
                                // style={{ maxWidth: '120px' }}
                                />
                            </div>

                            {/* CENTER: TITLE */}
                            <div
                                style={{
                                    flex: '1',
                                    textAlign: 'center',
                                }}
                            >
                                <h2 className="mb-10 mt-0">
                                    Article.
                                </h2>

                                <h2 className="text-red mb-1">
                                    VIRON Affiliate Program (“VAP”)
                                </h2>

                                <p style={{ fontSize: '14px', marginTop: '5px' }}>
                                    To Be Released: 09 January 2026
                                </p>
                            </div>

                            {/* RIGHT: SPACER (keeps center true) */}
                            <div
                                style={{
                                    flex: '0 0 auto',
                                    width: '120px',
                                }}
                                className="d-none d-md-block"
                            />
                        </div>


                        {/* STRUCTURE FOOTNOTES */}
                        <section style={{ marginBottom: '30px' }}>
                            <h4 className='text-center' style={{ fontWeight: 700 }}>Structure Footnotes.</h4>
                            <p>
                                When <strong>Vnetwork</strong> becomes the{' '} <strong><u>#1 on the TXC Leaderboard</u></strong>, the{' '}
                                <span style={{ color: '#0070c0', fontWeight: 600 }}>
                                    VIRON Affiliate Program (“VAP”)
                                </span>{' '}
                                will be in full effect.
                            </p>
                            <p>
                                That will also be when the{' '}
                                <span style={{ color: '#d00000', fontWeight: 600 }}>
                                    DIRECT REFERRALS (DRs)
                                </span>{' '}
                                will be fully available for purchase (*located in your VIRON.NETWORK back-office).
                            </p>
                        </section>

                        {/* VAP DETAILS */}
                        <section style={{ marginBottom: '30px' }}>
                            <h4 className='text-center' style={{ fontWeight: 700 }}>VAP Details.</h4>
                            <p>
                                Your{' '}
                                <span style={{ color: '#f4a300', fontWeight: 600 }}>
                                    VIRON Referral Link (VRL)
                                </span>{' '}
                                tracks <u>everyone</u> whom you have referred. The{' '}
                                <span style={{ color: '#f4a300', fontWeight: 600 }}>
                                    VRL&apos;s
                                </span>{' '}
                                data is for the purpose of paying out referral commissions
                                per the:{' '}
                                <span style={{ color: '#0070c0', fontWeight: 600 }}>
                                    VAP
                                </span>
                                , which is for <strong><u>3 Levels</u></strong>.
                            </p>

                            <p style={{ color: '#0070c0' }}>
                                <b>*Emphasis: The VAP is not only designed to be simple, but
                                    to give VIRON members compensation, even [if] the
                                    third-party MLM company does not have a compensation plan.</b> <i> *For example, the compensation of TXC itself changes from time to time and is
                                        currently <u>not feasible</u> for foreigners (members that are outside of the USA).</i>
                            </p>
                        </section>

                        {/* COMMISSION TABLE */}
                        <section style={{ marginBottom: '30px', overflowX: 'auto', textAlign: 'center' }}>
                            <h4 style={{ fontWeight: 700 }}>
                                VAP 3-Level Commission Amounts:
                            </h4>

                            <div style={{ display: 'flex', justifyContent: 'center', marginTop: '10px' }}>
                                <table style={{ minWidth: '240px' }}>
                                    <tbody>
                                        <tr>
                                            <td>Level <b className='text-light-blue'>1</b></td>
                                            <td>$45</td>
                                        </tr>
                                        <tr>
                                            <td>Level <b className='text-light-blue'>2</b></td>
                                            <td>$18</td>
                                        </tr>
                                        <tr>
                                            <td>Level <b className='text-light-blue'>3</b></td>
                                            <td>$9</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                            <hr style={{ border: '1px solid black', marginTop: '15px', marginBottom: '5px' }} />
                        </section>

                        {/* PAYOUT METHODS */}
                        <section style={{ marginBottom: '20px' }}>
                            <h4 style={{ fontWeight: 700 }}>
                                Payout methods available.
                            </h4>

                            <ul style={{ paddingLeft: '20px', fontWeight: 700 }}>
                                <li style={{ marginTop: '2px', fontWeight: 'normal', marginBottom: '0px' }}>Cryptocurrency: USDC-eth</li>
                                <li style={{ fontWeight: 'normal', marginBottom: '0px' }}>Cryptocurrency: USDT-Trx</li>
                                <li style={{ fontWeight: 'normal', marginBottom: '0px' }}>
                                    Fiat currency via: ZELLE, Payoneer, Wise, or Ria
                                </li>
                            </ul>
                        </section>

                        {/* ACCOUNTING */}
                        <section style={{ marginBottom: '20px' }}>
                            <h4 style={{ fontWeight: 700 }}>
                                VAP Accounting &amp; Payout Schedule.
                            </h4>

                            <ul style={{ paddingLeft: '20px', fontWeight: 700 }}>
                                <li style={{ fontWeight: 'normal', marginBottom: '0px' }}>
                                    The weekly cutoff for Accounting commissions calculations will be:<br />
                                    <u>USA, Central Standard Time (CST): Saturday 9PM</u>
                                    <ul style={{ listStyleType: 'circle', paddingLeft: '20px', marginTop: '5px' }}>
                                        <li style={{ fontWeight: 'normal', marginBottom: '0px' }}>
                                            Payouts will be disbursed weekly on <b><u>CST: Wednesdays 9AM</u></b>, until all
                                            commissions due are settled/paid.
                                        </li>
                                    </ul>
                                </li>
                            </ul>
                        </section>

                        {/* PAY EXAMPLE */}
                        <section style={{ marginBottom: '20px' }}>
                            <h4 style={{ fontWeight: 700 }}>
                                Pay Example of VAP - 3 Levels:
                            </h4>

                            <ol style={{ paddingLeft: '20px', marginTop: '10px', fontWeight: 700 }}>
                                <li style={{ fontWeight: 'normal' }}>
                                    When you refer John, YOU will be paid $45 for referring John (your Level 1).
                                </li>
                                <li style={{ fontWeight: 'normal' }}>
                                    When John refers Bob (Level 2), John is paid $45 and YOU will be paid $18 for John’s
                                    efforts.

                                </li>
                                <li style={{ fontWeight: 'normal' }}>
                                    When Bob refers Mary (Level 3), Bob will be paid $45, John will be paid $18, and YOU
                                    will be paid $9 for Bob’s efforts.
                                </li>
                            </ol>
                        </section>
                        <hr style={{ border: '1px solid black', marginTop: '15px', marginBottom: '5px' }} />

                        {/* FOOTER */}
                        <section style={{ marginBottom: '40px' }}>
                            {/* <p className='text-red text-center' style={{ lineHeight: '1.5' }}>
                                <b>To learn more about how cryptocurrency can help change your life TODAY, please visit:<br />
                                    <a href='https://www.viron.network/' className='text-light-blue'>https://www.VIRON.NETWORK</a> and register your account for Free.</b>
                            </p> */}

                            <div
                                style={{
                                    textAlign: 'center',
                                    marginTop: '30px',
                                    display: 'flex',
                                    flexDirection: 'column',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    gap: '5px',
                                }}
                            >
                                <p style={{ margin: 0 }}>
                                    Regards,
                                    <br /><br />
                                </p>

                                <img src="https://viron.network/assets/img/meet-our-team/Reverend-Abraham-Yew.jpg" alt="Reverend Abraham Yew" />

                                <div>
                                    <p style={{ marginBottom: '1px', fontWeight: 500 }}>Pastor Yew N. Song</p>
                                    <p className='mt-0 mb-0' style={{ fontSize: '14px', fontWeight: 400, }}> <i>Chief Financial Officer</i></p><br />
                                </div>
                                <p className='mt-0 mb-0'><b>VIRON NETWORK ADVISOR</b></p>
                                {/* <p className='text-light-blue mt-0'><b><a href='https://viron.network/' className='text-light-blue'>https://VIRON.NETWORK</a></b></p> */}
                            </div>
                        </section>

                        {/* DISCLAIMER */}
                        <section
                            style={{
                                maxWidth: '900px',
                                width: '100%',
                                margin: '20px auto 80px',
                                padding: '10px 10px',
                                border: '1px solid',
                                fontSize: '13px',
                                lineHeight: '1.6',
                                boxSizing: 'border-box',
                            }}
                        >
                            <p
                                style={{
                                    textAlign: 'center',
                                    fontWeight: 700,
                                    marginBottom: '1px'
                                }}
                            >
                                Earnings &amp; Income Disclaimer
                            </p>

                            <p
                                style={{
                                    textAlign: 'center',
                                    marginBottom: '10px',
                                }}
                            >
                                Past performance is not indicative of future results.
                            </p>

                            <p style={{ margin: 0 }}>
                                We make every effort to accurately represent our services and their potential for income.
                                Any statements made by VIRON or any third-party MLM program it markets are estimates of what
                                you can potentially earn as an individual. There are no guarantees, and by participating,
                                you acknowledge that earnings and income results may vary from one individual to another.
                                As with any income-producing endeavor, your results may differ and can be based on your
                                individual capacity, experience, and level of effort. Any testimonials presented by VIRON
                                members were not paid to endorse; however, they do earn compensation for promoting the
                                products and services offered.
                            </p>
                        </section>


                    </div>
                </div>
            </div>
        </Layout >
    );
}

export default AffilateProgramVAP;
